<div class="vessel-detail">
  <div class="page-header">
    <div>
      <div class="page-title">{{ vesselData?.name || ('vesselDetails' | translate) }}</div>
      <div class="page-subtitle" *ngIf="vesselData?.imo">IMO {{ vesselData?.imo }}</div>
    </div>
    <div class="button-area">
      <button *ngIf="!auth.isYakuin" class="detail-action-btn detail-action-btn--save" (click)="editVesselData()">edit data</button>
      <button *ngIf="!auth.isYakuin" class="detail-action-btn detail-action-btn--save" (click)="editVesselApplication()">edit application</button>
      <button class="detail-action-btn detail-action-btn--cancel" (click)="goBackList()">back</button>
      <button *ngIf="!auth.isYakuin" class="detail-action-btn detail-action-btn--delete" (click)="deleteVesselData()">delete</button>
    </div>
  </div>

  <div class="summary-card" *ngIf="vesselData">
    <div class="summary-title">{{ vesselData?.name }}</div>
    <div class="summary-meta">
      <span class="chip" *ngIf="vesselData?.imo">IMO {{ vesselData?.imo }}</span>
      <span class="chip" *ngIf="vesselData?.shipType">{{ vesselData?.shipType }}</span>
      <span class="chip" *ngIf="vesselData?.vesselType">{{ vesselData?.vesselType }}</span>
    </div>
  </div>

  <div class="section-card" *ngIf="vesselData">
    <div class="section-title">{{ 'vesselDetails' | translate }}</div>
    <div class="detail-grid">
      <div class="detail-item">
        <div class="detail-label">{{ 'vesselName' | translate }}</div>
        <div class="details">{{ vesselData?.name || '-' }}</div>
      </div>
      <div class="detail-item">
        <div class="detail-label">{{ 'otherName' | translate }}</div>
        <div class="details">{{ vesselData?.otherName || '-' }}</div>
      </div>
      <div class="detail-item">
        <div class="detail-label">{{ 'imo' | translate }}</div>
        <div class="details">{{ vesselData?.imo || '-' }}</div>
      </div>
      <div class="detail-item">
        <div class="detail-label">{{ 'vesselNumber' | translate }}</div>
        <div class="details">{{ vesselData?.vesselNumber || '-' }}</div>
      </div>
      <div class="detail-item">
        <div class="detail-label">{{ 'vesselType' | translate }}</div>
        <div class="details">{{ vesselData?.vesselType || '-' }}</div>
      </div>
      <div class="detail-item">
        <div class="detail-label">{{ 'shipType' | translate }}</div>
        <div class="details">{{ vesselData?.shipType || '-' }}</div>
      </div>
      <div class="detail-item">
        <div class="detail-label">{{ 'builtYear' | translate }}</div>
        <div class="details">{{ vesselData?.builtYear || '-' }}</div>
      </div>
      <div class="detail-item">
        <div class="detail-label">{{ 'callSign' | translate }}</div>
        <div class="details">{{ vesselData?.callsign || '-' }}</div>
      </div>
      <div class="detail-item">
        <div class="detail-label">{{ 'hotelPower' | translate }}</div>
        <div class="details">{{ vesselData?.hotelPower || '-' }}</div>
      </div>
      <div class="detail-item">
        <div class="detail-label">Owner</div>
        <div class="details">{{ vesselData?.vesselOwner?.name || '-' }}</div>
      </div>
      <div class="detail-item">
        <div class="detail-label">Manager</div>
        <div class="details">{{ vesselData?.vesselManagement?.name || '-' }}</div>
      </div>
      <div class="detail-item">
        <div class="detail-label">Builder</div>
        <div class="details">{{ vesselData?.vesselBuilder?.name || '-' }}</div>
      </div>
    </div>
  </div>
</div>
